import { actionsFromList } from '@mgc/map-client-shared/lib/ReduxTools';
import ErrorActions from './error';

class OfferActions {
    static types = actionsFromList([
        'RECEIVED_OFFERS',
        'REQUESTING_OFFERS',
        'SELECT_OFFER',
        'SELECT_PRODUCT',
    ]);

    // sync --------------------------------------------------------------------

    static requestingOffers = () => ({
        type: OfferActions.types.REQUESTING_OFFERS,
    });

    static receivedOffers = (response) => ({
        type: OfferActions.types.RECEIVED_OFFERS,
        payload: { response: response.data },
    });

    static selectOffer = (offerIndex) => ({
        type: OfferActions.types.SELECT_OFFER,
        payload: { offerIndex },
    });

    static selectProduct = (productIndex) => ({
        type: OfferActions.types.SELECT_PRODUCT,
        payload: { productIndex },
    });

    // async -------------------------------------------------------------------

    static requestOffers = () => (dispatch, getState) => {
        dispatch(OfferActions.requestingOffers());

        getState()
            .api.getMyOffers()
            .then((response) => dispatch(OfferActions.receivedOffers(response)))
            .catch(ErrorActions.errorHandler(dispatch));
    };
}

export default OfferActions;



// WEBPACK FOOTER //
// ./app/actions/offer.js